// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AW_1","buttons":"styles_buttons__3ywGX"};